(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-sort-form]');
    if (form) form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    const load = (container) => {
      if (container.dataset.loaded) return;
      container.dataset.loaded = 'true';
      fetch(container.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            container.innerHTML = fresh.innerHTML;
            if (window.Theme && window.Theme.reveal) window.Theme.reveal(container);
          }
        })
        .catch(() => {});
    };

    const init = (root) => {
      root.querySelectorAll('[data-recommendations]').forEach((container) => {
        if (!('IntersectionObserver' in window)) {
          load(container);
          return;
        }
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            load(container);
          },
          { rootMargin: '0px 0px 200px 0px' }
        );
        observer.observe(container);
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
